import ConnectedProductsGridComponent from "./connected-products-grid-component";
import ConnectedProductsGridConfig from "./connected-products-grid-config";
import ConnectedProductsGridAdvancedConfig from "./connected-products-grid-advanced-config";

export default {
  ConnectedProductsGridComponent,
  ConnectedProductsGridConfig,
  ConnectedProductsGridAdvancedConfig
};
